<template>
  <div>
    <el-dialog
      append-to-body
      :close-on-click-modal="false"
      title="Добавление компетенций"
      :visible.sync="show"
      width="70%"
      destroy-on-close
    >
      <el-row>
        <el-form
          size="small"
          label-position="top"
        >
          <el-form-item label="Целевой уровень" prop="targetScore">
            <el-input
              style="width: 200px"
              v-number-format="{decimals: 2, space:true}"
              :maxlength="6"
              v-model="targetScore"
            ></el-input>
          </el-form-item>
          <el-form-item label="Компетенции">
            <div class="filters-before-table" style="margin-top: 0">
              <search-input
                v-model="search"
                style="margin-right: 15px"
                prefix-icon="el-icon-search"
                placeholder="Поиск по названию"
                size="small"
                clearable
                @change="searchChanged"
              >
              </search-input>
              <categories-select
                size="small"
                :multiple="false"
                v-model="categoryId"
                @change="searchCompetencies"
              ></categories-select>
            </div>
            <el-table
              v-loading="loading"
              ref="selectCategoriesTable"
              size="mini"
              :data="competencies"
              :row-key="(row) => row.id"
            >
              <el-table-column type="selection" reserve-selection width="55"></el-table-column>
              <el-table-column prop="name" label="Название" width="400"></el-table-column>
              <el-table-column prop="description" label="Описание"></el-table-column>
              <el-table-column prop="category.name" label="Категория"></el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
        <paginator
          style="margin-bottom: 0"
          :paginator.sync="paginator"
          @page-changed="searchCompetencies"
        ></paginator>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="show = false">Отмена</el-button>
        <el-button
          :disabled="$refs.selectCategoriesTable && !$refs.selectCategoriesTable.selection.length"
          :loading="loading"
          type="primary"
          @click="addSelectedCompetencies"
          size="small"
          icon="fas fa-plus"
        >
          Добавить отмеченные
        </el-button>
      </div>
    </el-dialog>
    <span ref="wrapper">
      <slot name="reference"></slot>
    </span>
  </div>
</template>

<script>
import CategoriesSelect from "@/modules/evaluation/components/CategoriesSelect.vue";
import {off, on} from "element-ui/src/utils/dom";
import Paginator from "@/components/Paginator";
import {paginator} from "@/mixins/paginator";
import SearchInput from "@/components/filters/SearchInput.vue";

export default {
  name: "add-profile-competencies-dialog",
  mixins: [paginator],
  components: {SearchInput, CategoriesSelect, Paginator},
  data() {
    return {
      loading: false,
      show: false,
      search: null,
      categoryId: null,
      targetScore: null,
      competencies: [],
    }
  },
  mounted() {
    if (this.$refs.wrapper.children) {
      on(this.$refs.wrapper.children[0], 'click', this.open);
    }
  },
  methods: {
    open() {
      this.search = null;
      this.targetScore = null;
      this.paginator.page = 1;
      this.paginator.perPage = 10;
      this.show = true;
      this.competencies = [];

      this.searchCompetencies();
    },
    searchChanged() {
      this.paginator.page = 1;
      this.searchCompetencies();
    },
    searchCompetencies() {
      this.loading = true;

      this.$api.evaluation.competenceSearch({
        category_id: this.categoryId,
        profile_id: this.$route.params.id,
        search: this.search,
        expand: ['category'].join(),
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator}) => {
          this.competencies = data.competencies;
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    addSelectedCompetencies() {
      this.show = false;

      let newCompetenceIds = [];
      this.$refs.selectCategoriesTable.selection.forEach(competence => {
        newCompetenceIds.push(competence.id);
      })

      if (newCompetenceIds) {
        this.$api.evaluation.profileCompetenceCreate({
          competence_ids: newCompetenceIds,
          target_score: this.targetScore,
          profile_id: this.$route.params.id,
        })
          .then(data => {
            this.$notify.success({
              title: 'Сохранено',
              message: 'Компетенции успешно добавлены'
            });
          })
          .finally(()=>{
            this.loading = false;
            this.$emit('profile-competence-saved');
          })
      }
    },
  },
  beforeDestroy() {
    if (this.$refs.wrapper.children) {
      off(this.$refs.wrapper.children[0], 'click', this.open);
    }
  }
}
</script>

<style scoped>

</style>